module.exports = __webpack_public_path__ + "fonts/InstagramSans-Medium.f78303a6.ttf";